/*
 * Aura Golf - The Seam.
 *
 * A shared-element morph between the product grid (collection / search) and the
 * product page hero, using cross-document View Transitions. Click a product and
 * its image flies into the product page's hero position instead of a page flash.
 *
 * Pure progressive enhancement:
 *   - Browsers without cross-document View Transitions ignore this entirely and
 *     navigate normally (the pageswap/pagereveal events give a null viewTransition).
 *   - Users who prefer reduced motion get no animation at all.
 *   - Nothing here can block or delay a navigation; on any miss it is a normal load.
 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  var NAME = 'aura-product';
  var clickedImg = null;

  // Remember which product card was clicked; its image is the morph's origin.
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href*="/products/"]');
      if (!link) {
        clickedImg = null;
        return;
      }
      var scope =
        link.closest('.card-wrapper') ||
        link.closest('.grid__item') ||
        link.closest('.card');
      clickedImg = scope ? scope.querySelector('.card__media img') : null;
    },
    true
  );

  // Outgoing page: tag the clicked card image as the transition's "old" element.
  window.addEventListener('pageswap', function (event) {
    if (!event.viewTransition || !clickedImg) {
      return;
    }
    clickedImg.style.viewTransitionName = NAME;
    event.viewTransition.finished.finally(function () {
      if (clickedImg) {
        clickedImg.style.viewTransitionName = '';
      }
    });
  });

  // Incoming product page: tag the hero image as the transition's "new" element.
  window.addEventListener('pagereveal', function (event) {
    if (!event.viewTransition) {
      return;
    }
    var hero =
      document.querySelector('.product__media-item.is-active img') ||
      document.querySelector('.product__media-wrapper img');
    if (!hero) {
      return;
    }
    hero.style.viewTransitionName = NAME;
    event.viewTransition.finished.finally(function () {
      hero.style.viewTransitionName = '';
    });
  });
})();
